// What the UI offers. The backend decides (security/AccessPolicy); this only
// hides controls the user can't use.

export const ROLES = {
	USER: "USER",
	SUPER_USER: "SUPER_USER",
	ADMIN: "ADMIN",
};

export const ROLE_LABELS = {
	USER: "User",
	SUPER_USER: "Super user",
	ADMIN: "Admin",
};

export const isAdmin = (user) => user?.role === ROLES.ADMIN;
export const isSuperUser = (user) => user?.role === ROLES.SUPER_USER;

// Settings → Users: admins (everyone) and super users (regular users only)
export const canManageUsers = (user) => isAdmin(user) || isSuperUser(user);

// canModify is computed by the backend per item for the signed-in user. An item
// without it (not saved yet) is the user's own.
export const canModify = (item) => item?.canModify !== false;

// Another user's item the signed-in user may only view (and run, and clone)
export const isViewOnly = (item) => item?.canModify === false;
